<template>
  <div>
    <div class="content-work-intro" v-if="workIntro">
      <p class="content-work-intro-p" v-html="workIntro"></p>
    </div>
    <div class="form">
      <el-form
        ref="uploadFormRef"
        :model="form"
        size="medium"
        v-if="courseWorkFieldList.length"
      >
        <el-form-item
          v-for="(workField, index) in courseWorkFieldList"
          :key="workField.id"
          :label="`${workField.title}：`"
          :prop="`file${index}`"
          :rules="{
            required: workField.isRequired === 1,
            message: `请上传${workField.title}`,
          }"
        >
          <div class="file-item" v-if="code === 200003">
            <span class="text-overflow" :title="workField.fileName">
              {{ workField.fileName ? workField.fileName : "未上传" }}
            </span>
            <a
              class="download-btn"
              v-if="workField.fileUrl"
              download
              :href="workField.fileUrl"
            >
              下载
            </a>
          </div>
          <template v-else-if="code === 200004">
            <el-upload
              action
              :limit="1"
              :show-file-list="false"
              :multiple="false"
              :disabled="workField.disabled"
              :accept="workField.accept"
              :before-upload="(file) => onBeforeUpload(file, index, workField)"
            >
              <el-button
                :loading="workField.loading"
                :disabled="workField.disabled"
                size="mini"
              >
                上传
              </el-button>
            </el-upload>
            <!-- <p v-show="workField.loading">
                正在上传中，预计3-5分钟，请耐心等待，切勿关闭页面
              </p> -->
            <el-progress
              v-if="workField.progress"
              :percentage="workField.progress"
              text-color="#fff"
            />
            <p v-show="workField.fileName" class="text-overflow">
              {{ workField.fileName }}
              <i
                class="el-icon-close close-btn"
                style="cursor: pointer"
                @click="onDelete(index, workField)"
              >
              </i>
            </p>
            <!-- 9对应所有类型文件 -->
            <p>
              {{
                `${
                  !workField.typeList.includes(9)
                    ? genUploadType(workField.typeList).tip + "，"
                    : ""
                }文件大小不可超过${workField.maxSize}mb`
              }}
            </p>
          </template>
        </el-form-item>
        <el-form-item v-if="code === 200004">
          <el-button type="primary" @click="onSave"> 提交作品信息 </el-button>
          <p>信息一旦提交不可修改，请仔细核对</p>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import { saveCourseWorkInfo, getCourseWorkInfo } from "@/api/course";
import { getToken } from "@/api";
import request from "@/utils/request";

const fileTypeMap = new Map();
fileTypeMap.set(1, ".pdf");
fileTypeMap.set(2, ".jpg");
fileTypeMap.set(3, ".jpeg");
fileTypeMap.set(4, ".doc");
fileTypeMap.set(5, ".docx");
fileTypeMap.set(6, ".ppt");
fileTypeMap.set(7, ".pptx");
fileTypeMap.set(8, ".mp4");
fileTypeMap.set(9, ".*");

export default {
  name: "Work",
  data() {
    return {
      workIntro: "", //作业说明
      // 200003 上传过作品
      // 200004 未上传过作品，显示提交按钮
      // 500 错误响应，弹出提示即可  msg为红色警告，intro为蓝色说明区域文案
      code: undefined, // 区分状态

      form: {},
      courseWorkFieldList: [],
    };
  },
  computed: {
    courseId({ $route }) {
      return $route.query.courseId;
    },
    isLogin() {
      return !!localStorage.getItem("TOKEN");
    },
  },
  created() {
    this.getCourseWorkInfo();
  },
  methods: {
    onDelete(index, workField) {
      this.form[`file${index}`] = "";
      workField.fileName = "";
      workField.disabled = false;
    },
    onBeforeUpload(file, index, workField) {
      const fileName = file.name;
      const suffix = fileName.substr(fileName.lastIndexOf(".")).toLowerCase();
      let { typeList } = workField;
      typeList = [...typeList];
      typeList.forEach((item, index) => {
        typeList[index] = fileTypeMap.get(item);
      });

      if (!typeList.includes(".*") && !typeList.includes(suffix)) {
        this.$message.error(`请上传${typeList.join("、")}类型文件`);
        return false;
      }

      if (file.size > workField.maxSize * 1024 * 1024) {
        this.$message.error(`上传文件最大${workField.maxSize}M`);
        return false;
      }

      workField.loading = false;
      getToken(fileName)
        .then(({ data }) => {
          const { dir, filename, accessid, host, ...rest } = data;

          const formData = new FormData();
          Object.entries({
            name: filename,
            key: dir + filename,
            OSSAccessKeyId: accessid,
            success_action_status: "200", //让服务端返回200,不然，默认会返回204
            ...rest,
          }).forEach(([key, value]) => {
            formData.append(key, value);
          });

          formData.append("file", file);

          request({
            url: host,
            method: "post",
            data: formData,
            headers: {
              "Content-Type": "multipart/form-data",
            },
            onUploadProgress(progressEvent) {
              workField.progress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
            },
            timeout: 20 * 60 * 1000,
          })
            .then(({ data }) => {
              this.$message.success("上传成功");
              workField.fileName = file.name;
              this.form[`file${index}`] = data.fileUrl;
              workField.progress = 0;
            })
            .finally(() => {
              workField.loading = false;
              workField.disabled = true;
            });
        })
        .finally(() => {
          workField.loading = false;
          workField.disabled = true;
        });

      return false;
    },
    genUploadType(types) {
      types = types || [];
      const res = [];
      if (types.length) {
        types.forEach((type) => {
          switch (type) {
            case 1:
              res.push(".pdf");
              return;
            case 2:
              res.push(".jpg");
              return;
            case 3:
              res.push(".jpeg");
              return;
            case 4:
              res.push(".doc");
              return;
            case 5:
              res.push(".docx");
              return;
            case 6:
              res.push(".ppt");
              return;
            case 7:
              res.push(".pptx");
              return;
            case 8:
              res.push(".mp4");
              return;
            case 9:
              res.push(".*");
              return;
          }
        });
      }

      return {
        tip: `请上传${res.join("、")}类型文件`,
        accept: res.indexOf(".*") > -1 ? "" : res.join(","),
      };
    },
    getCourseWorkInfo() {
      getCourseWorkInfo(this.courseId).then(({ code, data }) => {
        this.code = code;
        this.workIntro = data.intro;
        const courseWorkFieldList = (data.courseWorkFieldList || []).map(
          (item) => ({
            disabled: false,
            progress: 0,
            accept: this.genUploadType(item.typeList).accept,
            loading: false,
            ...item,
          })
        );

        courseWorkFieldList.forEach((workField, index) => {
          this.$set(this.form, `file${index}`, "");
        });
        this.courseWorkFieldList = courseWorkFieldList;
      });
    },
    onSave() {
      this.$refs.uploadFormRef.validate(async (res) => {
        if (!res) return;

        const data = [];
        const { courseId, form } = this;

        this.courseWorkFieldList.forEach(
          ({ id, title, isRequired, sort, fileName }, index) => {
            data.push({
              id,
              courseId,
              title,
              isRequired,
              sort,
              fileName,
              fileUrl: form[`file${index}`],
            });
          }
        );

        saveCourseWorkInfo({ courseWorkFieldList: data, courseId }).then(() => {
          this.$message.success("提交成功");
          this.getCourseWorkInfo();
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.form {
  margin-top: 30px;
}

::v-deep .el-form-item__label {
  color: #fff;
}

.content-work {
  &-intro {
    width: 800px;
  }

  &-intro-p {
    display: inline-block;
    padding: 13px 20px;
    background-color: #e6f2ff;
    border-radius: 4px;
    color: #046bde;
  }
}

.file-item {
  display: flex;
  align-items: center;
}

.text-overflow {
  max-width: 400px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.download-btn{
  color: red;
}
</style>
